import { useEffect, useState } from 'react';
import { type UserInfo } from '@monorepo-hol/providers';

import type { PdfData } from '../../../types/documents';
import {
  type LangStateType,
  useLanguageContext,
} from '../../../provider/LanguageProvider';
import { useGetConsolidationDocument2 } from '../../../modules/document';
import type { DataDocumentDetail } from '../services/document-detail/types';
import type { AccessRight } from '../../../types/metadata';
import { MainCatalog } from '../../../types/catalog';

export interface UseConsolidationDataProps {
  guid: string;
  docId?: string;
  user: UserInfo;
  data: DataDocumentDetail;
  catalogAcl: AccessRight;
  catalogData: MainCatalog;
}

export interface IUseConsolidationData {
  isDocumentReady: boolean;
  isDocumentError: boolean;
  pdfDoc: PdfData;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pdfDocList?: any[];
  LangState: LangStateType;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  consolidationDocumentList?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  consolidationAppendices?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  consolidationDocument?: any;
}

export function useConsolidationData({
  guid,
  docId,
  data,
  user,
  catalogAcl,
  catalogData,
}: UseConsolidationDataProps): IUseConsolidationData {
  const [isDocumentReady, setIsDocumentReady] = useState(false);
  const [isDocumentError, setIsDocumentError] = useState(false);
  const [pdfDoc, setPdfDoc] = useState<PdfData>(null);
  const { LangState } = useLanguageContext();

  const { consolidationData, consolidationStatus, isConsolidationLoading } =
    useGetConsolidationDocument2({
      guid: guid,
      jwt: user?.jwt || '',
      type: 'consolidation',
      docId: catalogData?.pdfDocumentGuid,
      data,
      authorized: catalogAcl?.consolidations === 'authorized',
      mainDocument: catalogData?.mainDocument,
    });

  useEffect(() => {
    if (isConsolidationLoading) {
      setIsDocumentReady(false);
    } else if (consolidationStatus === 'success') {
      setIsDocumentReady(true);
      setPdfDoc(consolidationData);
    } else if (consolidationStatus === 'error') {
      setIsDocumentReady(true);
      setPdfDoc(consolidationData);
      setIsDocumentError(true);
    } else if (consolidationStatus === 'loading') {
      setIsDocumentReady(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consolidationStatus]);

  return {
    isDocumentReady,
    isDocumentError,
    pdfDoc,
    LangState,
    consolidationDocumentList: catalogData?.documentList,
  };
}
